@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.linkshare

import com.narbase.letsgo.dto.KmmLong
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.linkshare.LinkShareRewardSettingDto

object UpsertLinkShareRewardSettingEndpoint :
    EndPoint<UpsertLinkShareRewardSettingEndpoint.Request, UpsertLinkShareRewardSettingEndpoint.Response>() {
    class Request(
        val setting: LinkShareRewardSettingDto,
    )

    class Response(
        val id: KmmLong,
    )
}
